export enum ViewOption {
    GRID = 'grid',
    LIST = 'list',
}